import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ContactList } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchContactList = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(ContactList, { variables: { hotelID } });
};
